import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import Loading from 'uI/Loading/Loading';

import PlansContainer from '../PlansContainer/PlansContainer';

import { generalData } from 'constants/Preregister/generalData';
import {
  getPaymentPlans,
  sendInfo
} from 'store/preregister-actions';

import classes from './GeneralData.module.css';

const GeneralData = props => {
  const [showPlans, setShowPlans] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentPlans, setPaymentPlans] = useState([]);
  const [idPlan, setidPlan] = useState(0);
  const prevalueData = {
    firstName: props.userInfo.nombre,
    lastName: props.userInfo.apellido,
    email: props.userInfo.email
  };

  const { register, handleSubmit, watch } = useForm({
    defaultValues: prevalueData
  });

  const [program] = watch(['program']);

  useEffect(() => {
    setShowPlans(false);
    if (program) {
      (async () => {
        setPaymentPlans(await getPaymentPlans(program));
        setShowPlans(true);
      })();
    }
  }, [program]);

  useEffect(() => {
    if (paymentPlans.length > 0) {
      setidPlan(paymentPlans[0].planId);
    }
  }, [paymentPlans]);

  const onSubmit = async () => {
    setLoading(true);
    (async () => {
      const sendInfoData = await sendInfo(idPlan, 'form_data');
      if (sendInfoData) {
        props.reloadInfo();
      } else {
        setLoading(false);
      }
    })();
  };

  return (
    <form
      className={classes.formContainer}
      onSubmit={handleSubmit(onSubmit)}
    >
      {generalData.map(input => (
        <TextField
          key={input.value}
          className={classes.textField}
          {...register(input.value)}
          placeholder={input.label}
          type="text"
          label={input.label}
          disabled={input.disabled}
        />
      ))}
      <TextField
        placeholder="Programa al que desea inscribirse"
        {...register('program')}
        className={classes.textField}
        label="Programa al que desea inscribirse"
        select
      >
        {props.programs.map(item => (
          <MenuItem key={item.code} value={item.code}>
            {item.name}
          </MenuItem>
        ))}
      </TextField>
      {showPlans && (
        <PlansContainer
          showPlans={showPlans}
          paymentPlans={paymentPlans}
        />
      )}
      <div className={classes.btnContainer}>
        {!loading ? (
          <Button
            className={classes.btnSend}
            type="submit"
            disabled={!program}
          >
            Guardar
          </Button>
        ) : (
          <Loading />
        )}
      </div>
    </form>
  );
};

GeneralData.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userInfo: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  programs: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  reloadInfo: PropTypes.func
};

export default GeneralData;
